import { StyledMaxCharacterCountText } from './FormFieldMaxCharacterCount.style';

interface Props {
    fieldValue: string;
    maxCharacterCount: number;
    error?: boolean;
}

const FormFieldMaxCharacterCount = (props: Props) => {
    const { fieldValue, maxCharacterCount, error } = props;
    const characterCount = fieldValue?.length || 0;
    const isMaxCharacterCountReached = characterCount > maxCharacterCount;

    return (
        <StyledMaxCharacterCountText
            variant="caption"
            isMaxCharacterCountReached={isMaxCharacterCountReached}
            isError={error}
        >
            {characterCount}/{maxCharacterCount}
        </StyledMaxCharacterCountText>
    );
};

export default FormFieldMaxCharacterCount;
